<template>
  <div class="main">
    <div class="content">
      <div class="content-top suspended-box">
        <van-form ref="form" class="custom-form">
          <!-- 手机号码 -->
          <van-field
            class="custom-field"
            label="手机号码"
            v-model="mobile"
            placeholder="请输入手机号码"
            :rules="telRules"
            name="mobile"
          ></van-field>
          <!-- 验证码 -->
          <van-field
            class="custom-field"
            label="验证码"
            v-model="code"
            placeholder=""
            :rules="codeRules"
          >
            <template #button>
              <van-button
                class="custom-button"
                size="small"
                type="primary"
                :disabled="!isPhoneValid"
                @click="sendCode"
                >{{ codeMsg }}</van-button
              >
            </template>
          </van-field>
        </van-form>
      </div>
      <div class="custom-submit-button">
        <van-button
          style="background-color: #007aff; border-radius: 5px; height: 100%"
          type="primary"
          block
          @click="onSubmit"
          native-type="submit"
          >提交</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { jwtDecode } from "jwt-decode";
import { loginByPhoneAndCode, getPhoneCode } from "../api/index";
import { Toast } from "vant";

export default {
  data() {
    return {
      codeNum: 60,
      codeMsg: "获取验证码",
      count: "",
      mobile: "",
      code: "",
      loginForm: {
        mobile: "",
        code: "",
      },
      isPhoneValid: false, // 添加一个标志位来表示手机号码是否有效
      telRules: [
        { required: true, message: "请输入手机号码", trigger: "blur" },
        {
          pattern: /^1[345789]\d{9}$/,
          message: "请输入正确的手机号码格式",
          trigger: "blur",
        },
      ],
      codeRules: [{ required: true, message: "请输入验证码", trigger: "blur" }],
    };
  },
  watch: {
    mobile(newVal) {
      // 当手机号码变化时，检查它是否有效
      this.isPhoneValid = this.checkPhoneNumber(newVal);
    },
  },
  methods: {
    checkPhoneNumber(phoneNumber) {
      // 这里只是一个简单的正则表达式校验，您可以根据需要添加更复杂的逻辑
      const pattern = /^1[345789]\d{9}$/;
      return pattern.test(phoneNumber);
    },
    // 获取短信验证码
    async sendCode() {
      // 验证手机号格式是否正确
      if (!this.mobile || !this.isPhoneValid) {
        Toast({
          message: "请输入正确手机号！",
          position: "middle",
          duration: 2000,
        });
        return;
      }
      //发送请求
      await getPhoneCode({ phoneNo: this.mobile }).then((res) => {
        if (res.code === 0) {
          Toast.success("验证码已发送！");
          // 禁用按钮
          this.isPhoneValid = true;
          // 倒计时
          this.count = this.codeNum;
          let timer = setInterval(() => {
            if (this.count > 1 && this.count <= this.codeNum) {
              this.count--;
              this.codeMsg = `重新发送(${this.count})`;
            } else {
              // 判断什么时候停止定时器
              clearInterval(timer);
              this.codeMsg = "获取验证码";
              this.isPhoneValid = false;
              this.count = "";
            }
          }, 1000);
        } else {
          Toast({ message: res.msg, position: "middle", duration: 2000 });
        }
      });
    },
    async onSubmit() {
      this.loginForm.mobile = this.mobile;
      this.loginForm.code = this.code;
      //console.log(this.loginForm)
      // 网络请求
      let data = await loginByPhoneAndCode(this.loginForm);
      //console.log(data);
      if (data.code === 0) {
        // 本地  vuex
        this.$store.commit("LOGIN_IN", data.data);
        //登录成功跳转首页
        this.$router.push("/");
      } else {
        // 本地  vuex
        this.$store.commit("LOGIN_OUT");
        Toast({ message: "登录失败！", position: "middle", duration: 2000 });
      }
    },
  },
  mounted() {
    // 页面加载时，如果已经有手机号码，则检查其有效性
    this.isPhoneValid = this.checkPhoneNumber(this.mobile);
  },
};
</script>

<style scoped>
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100vh;
  padding: 16px;
  box-sizing: border-box;
  background-color: #f5f5f5; /* 背景色 */
}

.content {
  transform: translateY(22vh); /* 将组件向上移动视口高度的22% */  
  width: 100%;
  max-width: 600px;
}

.suspended-box {
  position: relative; /* 定位子元素 */
  background-color: #fff; /* 悬浮框背景色 */
  border-radius: 8px; /* 悬浮框圆角 */
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1); /* 添加阴影实现悬浮效果 */
  transform: translateY(-16px); /* 向上移动，增强悬浮感 */
  transition: transform 0.3s ease; /* 平滑过渡效果 */
  padding: 16px; /* 内边距 */
  margin-bottom: 16px; /* 底部间距 */
}

.custom-form {
  display: flex;
  flex-direction: column;
}

.custom-field {
  width: 100%;
  height: 8vh;
  align-content: center;
  align-items: center;
}

.custom-field label {
  font-size: 16px;
  color: #333;
}

.custom-field input {
  font-size: 16px;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.custom-button {
  margin-top: 10px;
  font-size: 14px;
}

.custom-submit-button {
  margin-top: 24px;
  height: 8vh;
}

.custom-submit-button van-button {
  font-size: 18px;
  width: 100%; /* 提交按钮占满宽度 */
  font-weight: bold; /* 字体加粗 */
}

/* 适配小屏幕 */
@media (max-width: 400px) {
  .content {
    padding: 8px;
  }

  .suspended-box {
    padding: 8px;
  }

  .custom-field label {
    font-size: 14px;
  }

  .custom-field input {
    font-size: 14px;
    padding: 8px;
  }

  .custom-button {
    font-size: 12px;
  }

  /* 添加鼠标悬停效果 */
  .suspended-box:hover {
    transform: translateY(-18px); /* 鼠标悬停时，再向上移动一些，增强视觉效果 */
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15); /* 加大阴影效果 */
  }

  /* 表单验证错误样式 */
  .van-field.van-field--error .van-field__label,
  .van-field.van-field--error .van-field__control {
    color: #f56c6c; /* 错误信息颜色 */
  }

  /* 适配中等屏幕 */
  @media (min-width: 401px) and (max-width: 768px) {
    .suspended-box {
      padding: 12px;
    }

    .custom-field input {
      font-size: 15px;
      padding: 10px;
    }

    .custom-button {
      font-size: 13px;
    }
  }

  /* 适配大屏幕 */
  @media (min-width: 769px) {
    .suspended-box {
      padding: 16px;
    }

    .custom-field input {
      font-size: 16px;
      padding: 12px;
    }

    .custom-button {
      font-size: 14px;
    }
  }
}
</style>
